<template>
  <div class="results-analysis">
    <div style="width: 1080px;padding: 40px 0 65px" class="flex-column items-center justify-center">
      <div class="title-box">
        <div class="ai-icon"></div>
        <div class="title-icon"></div>
      </div>
      <div class="title-message">上传技术成果，帮您深度解析技术优劣势</div>
      <div class="content-bg">
        <div class="content-box">
          <div class="input-content">
            <el-input
              type="textarea"
              resize="none"
              placeholder="您可以在这里描述您的成果，例如：
成果面向产业方向是：xxx；
主要解决问题是：xxx；
成果方案描述：xxx；
请推荐几家潜在的可以合作的机构。"
              v-model="textarea"
            >
            </el-input>
          </div>
          <div class="upload-file">
            <el-upload
              class="upload-demo"
              drag
              action="null"
              :multiple="false"
              :show-file-list="false"
              :auto-upload="false"
              :on-change="handleFileChange"
              accept=".doc, .docx, .xls, .xlsx, .pdf, .ppt, .pptx"
            >
              <div class="flex-column items-center justify-center" style="height: 100%" v-if="!uploadFile">
                <img width="40" height="32" :src="uploadIcon" alt="">
                <div class="upload_text">AI文档解析，<span>点击上传</span></div>
                <div class="upload-line"><div></div>上传格式<div></div></div>
                <div class="flex justify-center">
                  <div class="upload-img">
                    <img width="24" height="22" :src="word" alt="">
                    <img width="24" height="22" :src="excel" alt="">
                    <img width="22" height="22" :src="ppt" alt="">
                    <img width="22" height="22" :src="pdf" alt="">
                  </div>
                </div>
              </div>
              <div class="flex-column items-center justify-center show-file" v-else>
                <div class="flex-column items-center" style="cursor: default" @click.stop="()=>{}">
                  <img width="44" height="46" :src="fileType" alt="">
                  <p class="overflow overflow-2 file-name">{{ uploadFile.name }}</p>
                </div>
                <div class="operation-btn">
                  <span>重新上传</span>
                  <span @click.stop="deleteFile">删除</span>
                </div>
              </div>
            </el-upload>
          </div>
        </div>
      </div>
      <div class="upload-btn">
        <el-button :loading="loading" @click="handleSubmit">立即识别</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import uploadIcon from '@/assets/images/common/upload-icon.png';
import ppt from '@/assets/images/achievement/achievement-ppt.png';
import pdf from '@/assets/images/achievement/achievement-pdf.png';
import word from '@/assets/images/achievement/achievement-word.png';
import excel from '@/assets/images/achievement/achievement-excel.png';
import defaultFile from '@/assets/images/achievement/default-file.png';
import { resultsIndexMixin } from '@/mixin/resultsAnalysis/resultsMixin';

export default {
  name: 'resultsAnalysisGuoJiao',
  mixins: [ resultsIndexMixin ],
  components: {},
  props: {},
  data() {
    return {
      uploadIcon,
      ppt,
      pdf,
      word,
      excel,
      defaultFile,
    }
  },
  created() {
    document.title = '成果分析';
  },
  watch: {}
};
</script>

<style scoped lang="less">
.results-analysis {
  width: 100%;
  min-width: 100vw;
  min-height: 100vh; // calc(100vh - 62px)
  display: flex;
  justify-content: center;
  background-image: url("~@/assets/images/GuoJiao/bg.png");
  background-color: #D8E7FC;
  background-size: 100% 100%;
  background-position: 100% 100%;
  background-repeat: no-repeat;

  .title-box {
    display: flex;
    align-items: center;
    justify-content: center;
    .ai-icon {
      width: 53px;
      height: 52px;
      margin-right: 15px;
      background-size: 100% 100%;
      background-image: url("~@/assets/images/GuoJiao/ai-icon.png");
    }
    .title-icon {
      width: 228px;
      height: 43px;
      background-size: 100% 100%;
      background-image: url("~@/assets/images/GuoJiao/achievement-title.png");
    }
  }

  .title-message {
    font-family: PingFang SC;
    margin-top: 18px;
    font-size: 18px;
    font-weight: 500;
    display: flex;
    justify-content: center;
    color: #181F33;
    letter-spacing: 1px;
    opacity: 0.85;
    user-select: none;
  }

  .content-bg {
    width: 1080px;
    height: 450px;
    box-sizing: border-box;
    margin-top: 30px;
    padding: 20px;
    border: 1px solid rgba(61, 123, 225, 0.2);
    border-radius: 12px;
    background: rgba(61, 123, 225, 0.2);
    box-shadow: 0px 2px 8px 0px rgba(6,40,86,0.06);

    .content-box {
      display: flex;
      justify-content: space-between;
      height: 100%;
      background: #ffffff;
      border-radius: 12px;
      box-shadow: 0 2px 8px 0 rgba(6, 40, 86, 0.06);
    }

    .input-content {
      box-sizing: border-box;
      width: 50%;
      padding: 25px;
      border-right: 1px dashed #EDEDED;
    }


    /deep/ .el-textarea {
      height: 100%;
    }

    /deep/ .el-textarea__inner {
      color: #181F33 !important;
      border: none;
      height: 100%;
      padding: 0;
      font-size: 16px !important;
      &::placeholder {
        color: #8191B2;
      }
    }
    .upload-file{
      width:  50%;
      height: 100%;
      //padding: 20px;
    }
    .show-file {
      flex-shrink: 0;
      height: inherit;
      padding: 0 40px;
      .file-name {
        color: #666666;
        font-size: 14px;
        line-height: 16px;
        margin-top: 20px;
        cursor: default;
      }
      .operation-btn {
        margin-top: 14px;
        font-size: 14px;
        span+span {
          margin-left: 14px;
        }
        span {
          user-select: none;
          cursor: pointer;
          &:first-child {
            color: #1072EC;
          }
          &:last-child {
            color: tomato;
          }
        }
      }
    }
    /deep/.upload-demo{
      height: 100%;
      width: 100%;
    }
    /deep/.el-upload{
      height: 100%;
      width: 100%;
    }
    /deep/.el-upload-dragger{
      height: 100%;
      width: 100%;
      border-radius: unset;
      border: none;
      background: unset;
    }
    .upload_text{
      font-family: PingFang SC;
      color: #000000;
      font-size: 18px;
      margin-top: 19px;
      span{
        color: #1072EC;
        cursor: pointer;
      }
    }
    .upload-line{
      font-size: 14px;
      color: #bbc0c8;
      opacity: 0.65;
      justify-content: center;
      display: flex;
      align-items: center;
      margin-top: 50px;
      div{
        width: 98px;
        height: 1px;
        margin: 0 14px;
        opacity: 0.65;
        background-color: #EDEDED;
      }
    }
    .upload-img{
      margin-top: 20px;
      height: 22px;
      display: flex;
      width: 190px;
      justify-content: space-between;
    }
  }

  .upload-btn {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 30px;

    /deep/ .el-button {
      min-width: 100px;
      height: 36px;
      color: #ffffff;
      background: #3860F4;
      border: none !important;
      border-radius: 30px !important;
      //box-shadow: 0px -5px 12px 0px rgba(10,114,255,0.26), 0px 5px 12px 0px rgba(10,114,255,0.3);
    }
  }
}
</style>
